import React from "react";

export default function Tag({ children }) {
  return (
    <label className="rounded-md px-2 pt-1.5 pb-1 bg-lightGreen text-white text-xs font-semibold uppercase">
      {children}
    </label>
  );
}
